import React from 'react';
import { Outlet } from 'react-router-dom';
import Notifications from '../../modules/Notifications/components/Notifications';

export default function LoginLayout({ children }) {
  return (
    <>
      {/* <Notifications /> */}
      <Outlet />
    </>
  );
}
